import { basicEnum } from "./base";

export const ProvisionItemChangeStatusEnum = basicEnum([
    {
        label: "Kembali",
        value: "R", // Return
    },
    {
        label: "Ganti",
        value: "C",
    },
    {
        label: "Tetap",
        value: "U",
    },
]);

export namespace ProvisionItemChangeStatusEnum {
    export type Labels = (typeof ProvisionItemChangeStatusEnum)["labels"][number];
    export type Values = (typeof ProvisionItemChangeStatusEnum)["values"][number];
}
